import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
  gap: 1.5rem;
`;
